<template>
  <v-flex xs6 style="padding: 0 20px" v-if="activeLayer">
    <v-tabs
      v-model="activeLayer"
      :key="layersAsString"
      background-color="transparent"
      show-arrows
      height="20px"
      slider-color="primary"
    >
      <v-tab
        v-for="tab in layersToShow"
        :key="tab"
        :href="'#' + tab"
        style="font-size: 10px"
      >
        {{ $tc(getLayerTranslationKey(tab), 2) }}
      </v-tab>
    </v-tabs>

    <home-form-table-toolbar class="mt-2">
      <home-form-table-refresh-tool
        :disabled="!toolbarEnabled"
        @click="refreshTableData"
      />
      <home-form-table-select-all-tool
        :disabled="!toolbarEnabled"
        @click="selectAllTableRows"
      />
      <home-form-table-select-invert-tool
        :disabled="!toolbarEnabled"
        @click="invertTableRowsSelection"
      />
      <home-form-table-select-none-tool
        :disabled="!toolbarEnabled"
        @click="clearTableRowsSelection"
      />

      <div style="width: 100%" />
      <home-form-table-add-to-other-list-tool
        :disabled="!toolbarEnabled"
        @click="addAssetsToReservation"
      />
    </home-form-table-toolbar>

    <multiple-object-single-layer-table
      ref="objectDatatable"
      :layer="activeLayer"
      :field-filters="fieldFilters"
      :can-highlight-objects="true"
      :assetReservationTemplate="template"
      :asset-reservation-objects="assetReservationObjects"
      :only-used-elements="onlyUsedElements"
      @enable-toolbar="toolbarEnabled = $event"
      style="height: fit-content; overflow: scroll; max-height: 90%;"
    />
  </v-flex>
</template>

<script>
import HomeFormTableToolbar from "@/components/Home/Forms/_Atoms/TableToolbar";
import HomeFormTableRefreshTool from "@/components/Home/Forms/_Atoms/TableToolbarButtons/Refresh";
import HomeFormTableSelectAllTool from "@/components/Home/Forms/_Atoms/TableToolbarButtons/SelectAll";
import HomeFormTableSelectInvertTool from "@/components/Home/Forms/_Atoms/TableToolbarButtons/SelectInvert";
import HomeFormTableSelectNoneTool from "@/components/Home/Forms/_Atoms/TableToolbarButtons/SelectNone";
import HomeFormTableAddToOtherListTool from "@/components/Home/Forms/_Atoms/TableToolbarButtons/AddToList";
import MultipleObjectSingleLayerTable from "@/components/Home/Forms/_Organisms/MultipleObjectsSingleLayerTable";
import { bus } from "@/main";

export default {
  name: "AssetSelection",

  components: {
    MultipleObjectSingleLayerTable,
    HomeFormTableAddToOtherListTool,
    HomeFormTableSelectNoneTool,
    HomeFormTableSelectInvertTool,
    HomeFormTableSelectAllTool,
    HomeFormTableRefreshTool,
    HomeFormTableToolbar
  },

  props: {
    template: {
      type: Object
    },

    filters: {
      type: Array
    },

    layersToShow: {
      type: Array
    },
    assetReservationObjects: {
      type: Array
    },

    /**
     * Indicates if only used assets should be listed
     */
    onlyUsedElements: {
      type: Boolean
    }
  },

  data() {
    return {
      activeLayer: null,
      toolbarEnabled: false
    };
  },

  computed: {
    layersAsString() {
      return this.layersToShow.join(",");
    },

    activeLayerPrefix() {
      return this.$store.getters.getLayerInitials(this.activeLayer);
    },

    fieldFilters() {
      return this.filters.map(filter => {
        return {
          ...filter,
          field: this.activeLayerPrefix + "_" + filter.field
        };
      });
    }
  },

  watch: {
    layersToShow(newValue) {
      this.activeLayer = newValue[0];
    }
  },

  mounted() {
    if (this.layersToShow) {
      this.activeLayer = this.layersToShow[0];
    }
  },

  methods: {
    getLayerTranslationKey(layer) {
      return this.$store.getters.getLayerTranslationKey(layer);
    },

    refreshTableData() {
      this.$refs.objectDatatable.refresh();
    },

    selectAllTableRows() {
      this.$refs.objectDatatable.selectAll();
    },

    invertTableRowsSelection() {
      this.$refs.objectDatatable.invertSelection();
    },

    clearTableRowsSelection() {
      this.$refs.objectDatatable.clearSelection();
    },

    addAssetsToReservation() {
      let selectedObjects = this.$refs.objectDatatable.getSelectedObjects();
      bus.$emit("add-assets-to-asset-reservation", {
        layer: this.activeLayer,
        objects: selectedObjects
      });
      this.$refs.objectDatatable.resetSelectedIndexes();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/AssetReservationForm/AssetsTab/AssetSelection.vue